import { Link } from 'react-router-dom';
import { pillClass } from './SiteHeader';

export function NotFoundPanel() {
  return (
    <div className="flex min-h-full flex-col justify-center px-8 py-9">
      <p className="font-mono text-[10px] uppercase tracking-[0.14em] text-white/55">Not found</p>
      <h2 className="mt-2 text-[32px] font-[560] leading-[1.1] tracking-tight">No place here.</h2>
      <p className="mt-4 max-w-[34ch] text-[15px] leading-[1.6] text-white/70">
        This address doesn't match any place on the globe.
      </p>
      <Link to="/" className={`mt-6 self-start ${pillClass}`}>
        ← Back to globe
      </Link>
    </div>
  );
}
